import { IServiceAuth } from './IServiceAuth'
import type { IAuthRepository } from '../domain/IAuthRepository'
import { authRequest } from '../domain/authRequest'
import { authResponse } from '../domain/authResponse'
import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'
import { IapmUser } from '../../user/domain/iapmUser'
import { appConfigResponse } from '../domain/appConfigResponse'
import { autoAuthRequest } from '../domain/autoAuthRequest'



@injectable()
export class AuthService implements IServiceAuth {
  private readonly authRepo: IAuthRepository

  public constructor (@inject(TYPES.AUTH_REPOSITORY) _authRepo: IAuthRepository) {
    this.authRepo = _authRepo
  }

  async auth (request: authRequest): (Promise<authResponse>) {
    return await this.authRepo.auth(request)
  }

  async autoAuth (request: autoAuthRequest): (Promise<authResponse>) {
    return await this.authRepo.autoAuth(request)
  }

  async logout (): (Promise<boolean>) {
    return await this.authRepo.logout()
  }

  async getVersion (): (Promise<string>) {
    return await this.authRepo.getVersion()
  }

  async whoAmI (): (Promise<IapmUser>) {
    return await this.authRepo.whoAmI()
  }

  async whoAmIProfiles (): (Promise<IapmUser>) {
    return await this.authRepo.whoAmIProfiles()
  }

  async getAppConfig (applicationId: number, applicationVersion: number): (Promise<appConfigResponse>) {
    return await this.authRepo.getAppConfig(applicationId, applicationVersion)
  }

}
